export default __webpack_public_path__ + "static/media/27 Track 27.2f916fd0.mp3";